export class ConceptFamilyModel {

    uid: string;
    name: string;
    description: string;
    imageId: number;
    isDirectPosAccessTpv?: boolean;

    constructor() { }
}
